import { useState } from "react"

export const ProductState = () => {
	const [sform, setSForm] = useState({
        status: {value:0, msg:'', stat:false },
        from: {value:'', msg:'', stat:false },
        to: {value:'', msg:'', stat:false },
        filterBy: {value:1, msg:'', stat:false },
    })
	const [sdata, setSdata] = useState([])
	const [stat, setStat] = useState([
		{id:1, name:'received'},
		{id:2, name:'preparing'},
		{id:3, name:'shipped'},
		{id:4, name:'delivered'},
		{id:5, name:'confirmed'},
	])

	return {
		sform:{data:sform, set: setSForm},
		sdata:{data:sdata, set: setSdata},
		stat:{data:stat, set: setStat},
	}
}
